var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-139 -1055)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(139 1055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "target_3_",
    "data-name": "target (3)",
    transform: "translate(159.118 1072.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M124.492,102.339,95.135,127.18,70.294,156.537a38.324,38.324,0,0,0,54.2-54.2Z",
    transform: "translate(-59.07 -85.997)",
    fill: "#cc295f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M11.224,43.269a38.324,38.324,0,0,0,0,54.2l54.2-54.2a38.324,38.324,0,0,0-54.2,0Z",
    transform: "translate(0 -26.928)",
    fill: "#f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M146.15,134.159l-24.276,19.76L102.114,178.2a31.138,31.138,0,1,0,44.036-44.036Z",
    transform: "translate(-85.809 -112.736)",
    fill: "#ece6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M54.12,86.165a31.138,31.138,0,0,0,0,44.036L98.156,86.165A31.138,31.138,0,0,0,54.12,86.165Z",
    transform: "translate(-37.815 -64.742)",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M167.808,165.979l-19.2,14.679-14.679,19.2a23.952,23.952,0,0,0,33.874-33.874Z",
    transform: "translate(-112.547 -139.475)",
    fill: "#cc295f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M97.015,129.06a23.952,23.952,0,0,0,0,33.874l33.874-33.874A23.952,23.952,0,0,0,97.015,129.06Z",
    transform: "translate(-75.629 -102.556)",
    fill: "#f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M189.466,197.8l-14.114,9.6-9.6,14.114A16.767,16.767,0,1,0,189.466,197.8Z",
    transform: "translate(-139.286 -166.214)",
    fill: "#ece6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M139.911,171.956a16.767,16.767,0,0,0,0,23.712l23.712-23.712a16.767,16.767,0,0,0-23.712,0Z",
    transform: "translate(-113.443 -140.371)",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M211.123,229.619l-9.033,4.516-4.516,9.033a9.581,9.581,0,1,0,13.55-13.55Z",
    transform: "translate(-166.024 -192.953)",
    fill: "#cc295f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M182.807,214.851a9.581,9.581,0,0,0,0,13.55l13.55-13.55A9.581,9.581,0,0,0,182.807,214.851Z",
    transform: "translate(-151.258 -178.185)",
    fill: "#f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M240,165.531l1.694,1.694,16.853-16.853h0l-.565-5.081Z",
    transform: "translate(-201.677 -122.091)",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M246.247,152.926,229.394,169.78l1.694,1.694L250.2,152.362Z",
    transform: "translate(-192.764 -128.032)",
    fill: "#404a80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M345.542,84.9l1.694,1.694,13.192-1.388,11.7-11.7L361.048,69.4,352.1,73.834Z",
    transform: "translate(-290.365 -58.317)",
    fill: "#cfcfe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M352.135,11.082h0L348.025,0l-11.7,11.7-1.388,13.192,1.694,1.694Z",
    transform: "translate(-281.452)",
    fill: "#ece6f2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon);
export default __webpack_public_path__ + "static/media/missionIcon.e7b3ccdacdc568ca9922028652b8cc53.svg";
export { ForwardRef as ReactComponent };